import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { Text } from '../typography/Text';
import { BaseProps } from '../common/props';
import { formatNumber } from '@mc/react-format';
import { ReactNode } from 'react';

type Props = Omit<BaseProps, 'title'> & {
  // Počet všech záznamů
  totalElements?: number;
  // Nadpis tabulky listu apod.
  title?: ReactNode;
};

export const DataTableExtra = ({
  className,
  style,
  title,
  children,
  totalElements,
}: Props) => {
  return (
    <div
      className={classNames(Classes.DATA_TABLE_EXTRA, className)}
      style={style}
    >
      <div className={Classes.DATA_TABLE_EXTRA_LEFT}>
        {title && <div className={Classes.DATA_TABLE_EXTRA_TITLE}>{title}</div>}
        {children && (
          <div className={Classes.DATA_TABLE_EXTRA_CONTENT}>{children}</div>
        )}
      </div>
      <div className={Classes.DATA_TABLE_EXTRA_RIGHT}>
        {totalElements !== undefined && (
          <div>
            Počet záznamů: <Text strong>{formatNumber(totalElements)}</Text>
          </div>
        )}
      </div>
    </div>
  );
};
